import { ApiKey } from '../api-key.model';
import { ApiKeyActionTypes, ApiKeyActions } from '../actions/api-key.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface ApiKeyTypeState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export interface ApiKeyUsageState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforGetApiKeyUsage: ApiKeyUsageState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: ApiKeyActions
): State {
  switch (action.type) {

    case ApiKeyActionTypes.UpsertApiKey: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case ApiKeyActionTypes.GetApiKeys: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case ApiKeyActionTypes.GetApiKeysFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function getApiKeyUsageReducer(
  state = initialStateforGetApiKeyUsage,
  action: ApiKeyActions
): ApiKeyUsageState {
  switch (action.type) {

    case ApiKeyActionTypes.GetApiKeyUsage: {
      return {...state, Loaded: false, Loading: true};
    }

    case ApiKeyActionTypes.UpsertApiKeyUsage: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case ApiKeyActionTypes.GetApiKeyUsageFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const getApiKeyUsageState = (state: ApiKeyUsageState) => state;
